import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: calc((100vw - 1120px) / 2.3 + 1em);

  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `}
`;

export const ContainerInformations = styled.div`
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const ContainerImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${({ bgColorImage }) =>
    css`
      background-color: ${bgColorImage};
    `}
`;

export const ContentImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
`;
